export enum FONT_WEIGHT {
  light = 300,
  normal = 400,
  bold = 700,
}
